import { render, staticRenderFns } from "./ProductClassifyAdd.vue?vue&type=template&id=4bac2160&scoped=true&"
import script from "./ProductClassifyAdd.vue?vue&type=script&lang=js&"
export * from "./ProductClassifyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac2160",
  null
  
)

export default component.exports